module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interviewAborted":"Unfortunately, the interview has stopped because you answered for too long. Refresh the page, and the interview will continue from where you stopped.","continue":"Continue"}}')
  delete Component.options._Ctor
}
